import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import deliverUnifiedCustomerExperiencesPng2x from './assets/DeliverUnifiedCustomerExperiences@2x.png'
import deliverUnifiedCustomerExperiencesWebp from './assets/DeliverUnifiedCustomerExperiences.webp'
import deliverUnifiedCustomerExperiencesWebp2x from './assets/DeliverUnifiedCustomerExperiences@2x.webp'

const DeliverUnifiedCustomerExperiencesImage = () => {
  return (
    <picture>
      <source
        type="image/webp"
        srcSet={`${deliverUnifiedCustomerExperiencesWebp}, ${deliverUnifiedCustomerExperiencesWebp2x} 2x`}
      />
      <StyledImage
        src={deliverUnifiedCustomerExperiencesPng2x}
        alt="Illustration: Deliver Unified Customer Experiences"
        width="640"
        height="411"
        loading="lazy"
      />
    </picture>
  )
}

const StyledImage = styled(Image)`
  ${({ theme }) => theme.breakpoints.up(`md`)} {
    margin-top: 80px;
  }
`

export default DeliverUnifiedCustomerExperiencesImage
